import { performAttendanceCheckOut } from "./attendanceFlow";
import { clearSessionActivity } from "./sessionTimeout";

/** Shared logout: attendance check-out (if applicable) then clear session. Never throws. */
export async function logoutWithCheckout(logoutFn) {
  try {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const sessionUser = JSON.parse(storedUser);
      if (sessionUser?.id) {
        await performAttendanceCheckOut({
          roleName: sessionUser.roleName,
          userId: sessionUser.id,
          mobile: sessionUser.mobile,
        });
      }
    }
  } catch (error) {
    console.warn("Checkout failed during logout, continuing with logout:", error);
  }

  clearSessionActivity();
  logoutFn();
}
